import VAvatar from './VAvatar';
import VAvatarOption from './VAvatarOption';
import VAvatarBrief from './VAvatarBrief';
import VAvatarNickname from './VAvatarNickname';

import VCascaderCardType from './VCascaderCardType';
import VCascaderStore from './VCascaderStore';
import VColumnAvatar from './VColumnAvatar';
import VColumnAdmin from './VColumnAdmin';
import VColumnStudent from './VColumnStudent';
import VColumnTime from './VColumnTime';

import VDialogPersonnel from './VDialogPersonnel/index.js';
import VDialogTeacherAddApply from './VDialogTeacherAddApply';
import VDialogUpdateRecord from './VDialogUpdateRecord';
import VDatePickerSchedule from './VDatePickerSchedule';


import VEmpty from './VEmpty';

import VIcon from './VIcon';
import VImg from './VImg';
import VImageUpload from './VImageUpload';
import VRemarkFileList from './VRemarkFileList';
import VMultiFileUpload from './VMultiFileUpload';
import VInputAdministratorPhone from './VInputAdministratorPhone';
import VInputPhone from './VInputPhone';
import VInputCardNumber from './VInputCardNumber';
import VInputYouZanNumber from './VInputYouZanNumber';
import VInputMoney from './VInputMoney';
import VInputNumber from './VInputNumber';
import VInputPercentage from './VInputPercentage';

import VListButton from './VListButton';

import VMonthRangePicker from './VMonthRangePicker';

import VSelectAdministrator from './VSelectAdministrator';
import VSelectAdministratorRole from './VSelectAdministratorRole';
import VSelectApplyState from './VSelectApplyState';
import VSearchInput from './VSearchInput';
import VSelectStore from './VSelectStore';
import VSelectStudent from './VSelectStudent';
import VSelectTeacher from './VSelectTeacher';
import VSelectSubTeacher from './VSelectSubTeacher';
import VSelectCard from './VSelectCard';
import VSelectCardChargeType from './VSelectCardChargeType';
import VSelectCardList from './VSelectCardList';
import VSelectCardPaymentMode from './VSelectCardPaymentMode';
import VSelectCardState from './VSelectCardState';
import VSelectCardUpdateState from './VSelectCardUpdateState';
import VSelectCardTicketList from './VSelectCardTicketList';
import VSelectCardTicketState from './VSelectCardTicketState';
import VSelectCardTicketType from './VSelectCardTicketType';
import VCardTicketWarning from './VCardTicketWarning';
import VSelectCardType from './VSelectCardType';
import VSelectCardTypeId from './VSelectCardTypeId';
import VSelectCardUpdateType from './VSelectCardUpdateType';
import VSelectCourse from './VSelectCourse';
import VSelectCourseStyle from './VSelectCourseStyle';
import VSelectCourseDifficulty from './VSelectCourseDifficulty';
import VSelectCourseAge from './VSelectCourseAge';
import VSelectCourseColumn from './VSelectCourseColumn';
import VSelectCourseCover from './VSelectCourseCover';
import VSelectCourseVideo from './VSelectCourseVideo';
import VSelectCourseTag from './VSelectCourseTag';
import VSelectCourseTip from './VSelectCourseTip';
import VSelectCourseWhitelist from './VSelectCourseWhitelist';
import VSelectCustomer from './VSelectCustomer';
import VSelectIntegralActivity from './VSelectIntegralActivity';
import VSelectInvoiceClass from './VSelectInvoiceClass';
import VSelectIsNumberLimit from './VSelectIsNumberLimit';
import VSelectOptionDetail from './VSelectOptionDetail';
import VSelectReserveState from './VSelectReserveState';
import VSelectStudentUpdateType from './VSelectStudentUpdateType';
import VSelectVideoSort from './VSelectVideoSort';
import VSelectVoucherIssueType from './VSelectVoucherIssueType';
import VSelectVoucherStatus from './VSelectVoucherStatus';
import VSelectVoucher from './VSelectVoucher';
import VSelectVoucherType from './VSelectVoucherType';

import VPageStudentViewRecord from './VPageStudentViewRecord';
import VPageCardList from './VPageCardList';
import VPageCourseReservationRecord from './VPageCourseReservationRecord';
import VPageCardAddRecord from './VPageCardAddRecord';
import VPageCardTicketAddRecord from './VPageCardTicketAddRecord';
import VPageCardUpdateRecord from './VPageCardUpdateRecord';
import VPageVoucherAddRecord from './VPageVoucherAddRecord';
import VPageReservationList from './VPageReservationList';
import VPageStudentUpdateRecord from './VPageStudentUpdateRecord';
import VPageIntegralUpdateRecord from './VPageIntegralUpdateRecord';
import VPageTeacherRankList from './VPageTeacherRankList';
import VPagination from './VPagination';
import VPopover from './VPopover';
import VPopoverItem from './VPopoverItem';

import VPurchaseScopeRules from './VPurchaseScopeRules';

import VQrCode from './VQrCode';

import VTable from './VTable';
import VTabQuickTime from './VTabQuickTime';

import VVideoCover from './VVideoCover';
import VVideoUpload from './VVideoUpload';

export default {
  VAvatar,
  VAvatarOption,
  VAvatarBrief,
  VAvatarNickname,

  VCascaderStore,
  VCascaderCardType,

  VColumnAvatar,
  VColumnAdmin,
  VColumnStudent,
  VColumnTime,

  VDatePickerSchedule,
  VDialogPersonnel,
  VDialogTeacherAddApply,
  VDialogUpdateRecord,

  VEmpty,

  VIcon,
  VImg,
  VImageUpload,
  VMultiFileUpload,
  VRemarkFileList,
  VInputPhone,
  VInputAdministratorPhone,
  VInputCardNumber,
  VInputYouZanNumber,
  VInputMoney,
  VInputNumber,
  VInputPercentage,

  VListButton,

  VMonthRangePicker,

  VSearchInput,
  VSelectAdministrator,
  VSelectAdministratorRole,
  VSelectApplyState,
  VSelectCard,
  VSelectCardChargeType,
  VSelectCardList,
  VSelectCardPaymentMode,
  VSelectCardState,
  VSelectCardUpdateState,
  VSelectCardTicketList,
  VSelectCardTicketState,
  VSelectCardTicketType,
  VCardTicketWarning,
  VSelectCardType,
  VSelectCardTypeId,
  VSelectCardUpdateType,
  VSelectStore,
  VSelectStudent,
  VSelectTeacher,
  VSelectSubTeacher,
  VSelectCourse,
  VSelectCourseAge,
  VSelectCourseCover,
  VSelectCourseColumn,
  VSelectCourseDifficulty,
  VSelectCourseStyle,
  VSelectCourseVideo,
  VSelectCourseTag,
  VSelectCourseTip,
  VSelectCourseWhitelist,
  VSelectCustomer,
  VSelectIntegralActivity,
  VSelectInvoiceClass,
  VSelectIsNumberLimit,
  VSelectOptionDetail,
  VSelectReserveState,
  VSelectStudentUpdateType,
  VSelectVideoSort,
  VSelectVoucherIssueType,
  VSelectVoucherStatus,
  VSelectVoucher,
  VSelectVoucherType,
  VPageStudentViewRecord,

  VPageCardList,
  VPageCourseReservationRecord,
  VPageCardAddRecord,
  VPageCardTicketAddRecord,
  VPageCardUpdateRecord,
  VPageVoucherAddRecord,
  VPageReservationList,
  VPageStudentUpdateRecord,
  VPageIntegralUpdateRecord,
  VPageTeacherRankList,
  VPagination,
  VPopover,
  VPopoverItem,

  VPurchaseScopeRules,

  VQrCode,

  VTable,
  VTabQuickTime,

  VVideoCover,
  VVideoUpload,
};
